
  Vue.prototype.seekerUserInvitesFormRequest = [
    {
      id: 0,
      fieldName: 'WidgetId',
      label: 'Seleziona un widget tra quelli disponibili',
      inputType: 'radio',
      options: [
        { id: 1, valueIfChecked: '1', label: 'Widget standard' },
        { id: 1774, valueIfChecked: '1774', label: 'Sondaggio alunni zenale' }
      ],
      validators: [{ type: 'required' }]
    },
    {
      id: 1,
      fieldName: 'Skip',
      skip: true
    },
    {
      id: 2,
      fieldName: 'EmailList',
      inputType: 'textarea',
      nobr: true,
      label: 'Email',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex:
            /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+(\s*[;.]\s*(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*\s*;*\s*$/,
          message:
            'Sono stati riscontrati degli errori. Verifica che tutti gli indirizzi siano indicati correttamente e che siano separati da un ;'
        }
      ]
    }
  ]
